<template>
    <!-- View Call Report -->
    <div class="page-layout blank contacts-manage ml-3">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-10" v-else-if="!ajaxCallInProgress">
            <div class="breadcrumbnew">
                <a>Call Report</a>
                <router-link to="/callreportlist">List View</router-link>
                <span>View Call Report</span>
            </div>
            <div class="design-block px-10">
                <h2 class="headerblock">
                    <div class="d-flex">
                        <div class="w-100">
                            <el-tooltip class="item pull-left" effect="dark" content="Click to Go Back" placement="top">
                                <button @click="goBackToList" class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-left"></i>
                                </button>
                            </el-tooltip>
                            <!-- </router-link> -->
                            <img class="ml-15"
                                :src="callReportData.company_logo||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/company-logo.png'"
                                :alt="callReportData.company_name" width="70px" />
                                <span class="ml-3 fs-14 fw-600">{{callReportData.call_report_number}}</span>
                        </div>
                        <div class="text-center w-100 fw-600 fs-20" style="text-transform: uppercase; color: #303031;">
                            {{callReportData.company_name}}
                        </div>
                        <div class="text-right w-100 d-flex justify-content-end">
                            <div classs="mr-1">
                                <el-dropdown @click="handleClick" trigger="click">
                                    <span class="btn btn-new-darksuccess btn-des mr-1">
                                        <img src="/static/images/exports.svg" alt="export img" />
                                        <span class="text-white font-weight-bold ml-1 hidden-sm-down">Export</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>PDF</el-dropdown-item>
                                        <el-dropdown-item>XLSX</el-dropdown-item>
                                        <el-dropdown-item>CSV</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="d-flex">
                                <button class="btn btn-new-darkdanger btn-des mr-1">
                                    <img src="/static/images/pdf-file.svg" alt="pdf img" />
                                    <span class="text-white font-weight-bold ml-1 hidden-sm-down">Pdf</span>
                                </button>
                                <button class="btn btn-new-primary btn-des" @click="print('printId')">
                                    <img src="/static/images/printer.svg" alt="print img"/>
                                    <span class="text-white font-weight-bold ml-1 hidden-sm-down">Print</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </h2>
                <div class="page-layout carded left-sidebar w-100" id="printId"
                    style="border: 0px solid rgb(148, 190, 240) !important;border-radius: 0px !important;">
                    <div class="page-content-wrapper w-100" style="padding: 0 0rem;">
                        <div class="page-content custom-scrollbar" style="background-color: transparent !important;">
                            <div class="row" style="display:block;">
                                <div class="col-lg-12">
                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <div class="callreport-example">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">CALL REPORT TITLE</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-4">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Title
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            <!-- CRM Update -->
                                                                            {{callReportData.title}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <div class="qrcodecr-block float-right mr-20 mt-2">
                                                                        <img src="/static/images/qr-code.svg"
                                                                            class="qrcr-logo" />
                                                                        <qrcode-vue :value="valueqr" :size="size"
                                                                            level="H" background="#fff"
                                                                            foreground="#00448b"
                                                                            class="qrcodecr-content"></qrcode-vue>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-4">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Author
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span
                                                                            style="display: block; min-height: 15.5px;">
                                                                            <!-- CRM Update -->
                                                                            {{callReportData.author_name}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-4">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Author
                                                                        Email</span>
                                                                    <div class="callreport-details">
                                                                        <span
                                                                            style="display: block; min-height: 15.5px;">
                                                                            <!-- CRM Update -->
                                                                            {{callReportData.author_email}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="callReportData.call_report_category == 'External Meeting' || callReportData.call_report_category == 'Sales Meeting' || callReportData.call_report_category == 'Release Notes'">
                                        <div class="row" >
                                            <div class="col-lg-12" >
                                                <div class="callreport-example mb-5">
                                                    <div class="description descriptionblue" style="border-radius: 5px 5px 0px 0px;">
                                                        <div class="description-text">
                                                            <h5 class="pl-4 text-uppercase">Receiver Type</h5>
                                                        </div>
                                                    </div>
                                                    <div class="call-report-section" style="background: #fff;border-radius: 0px 0px 5px 5px;" >
                                                        <div clss="callreportview">
                                                            <div class="pl-8 pr-10 py-5">
                                                                <div class="row" >
                                                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                                                        <div class="d-flex align-items-center my-3">
                                                                            <span class="text-secondary whiteSpace fs-14 fw-600 mr-3">Receiver type :</span>
                                                                            <div
                                                                                class="d-flex justify-content-between mr-2 align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mb-1 ">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="lead"
                                                                                            name="receiver_lead"
                                                                                            disabled
                                                                                            v-model="callReportData.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span class="text-secondary fs-14 fw-600 mr-7">Lead</span>
                                                                            </div>
                                                                            <div  class="d-flex justify-content-between align-items-center">
                                                                                <div class="form-check form-check-inline mr-2 mb-1">
                                                                                    <label class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="contact"
                                                                                            name="receiver_contact"
                                                                                            disabled
                                                                                            v-model="callReportData.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span class="text-secondary fs-14 fw-600 mr-7">Contact</span>
                                                                            </div>
                                                                            <div class="d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mr-2 mb-1  ">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="customer"
                                                                                            name="receiver_customer"
                                                                                            disabled
                                                                                            v-model="callReportData.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span class="text-secondary fs-14 fw-600 mr-7">Customer</span>
                                                                            </div>
                                                                            <div
                                                                                class="d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mr-2 mb-1">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="vendor" disabled
                                                                                            name="receiver_vendor"

                                                                                            v-model="callReportData.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span
                                                                                    class="text-secondary fs-14 fw-600 mr-7">Vendor</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="callReportData.receiver_type == 'customer'">
                                            <div class="col-lg-12" >
                                                <div class="callreport-example mb-5" v-for="(external, index) in callReportData.external_attendees" :key="index">
                                                    <div class="description descriptionblue" style="border-radius: 5px 5px 0px 0px;">
                                                        <div class="description-text">
                                                            <h5 class="pl-4 text-uppercase">Receiver Details</h5>
                                                        </div>
                                                    </div>
                                                    <div class="call-report-section" style="background: #fff;border-radius: 0px 0px 5px 5px;" >
                                                        <div clss="callreportview">
                                                            <div class="pl-8 pr-10 py-5">
                                                                <div class="row" >
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Company Name</span>
                                                                        <div class="row">
                                                                            <div class="col-lg-8 callreport-details">
                                                                                <span>{{external.name || "-"}}</span>
                                                                            </div>
                                                                            <div class="callreport-details pt-2 col-lg-4">
                                                                                <button class="btn btn-new-primary btn-des ml-5">
                                                                                    <span class="text-white font-weight-bold ml-1 hidden-sm-down" @click="viewCustomer(external.id);">View Customer</span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pr-5 mt-7" >
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Primary Attendee</span>
                                                                        <div class="callreport-details-email">
                                                                            <span class="chipmailCallReport">
                                                                                <!-- Demo -->
                                                                                {{external.primary_email || "-"}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row" >
                                                                    <div class="col-lg-6 pr-5 mt-5" >
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Branch Name</span>
                                                                        <div class="callreport-details">
                                                                            <span>
                                                                                <!-- Sales -->
                                                                                {{external.branch || '-'}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pr-5 mt-5" >
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Department Name</span>
                                                                        <div class="callreport-details">
                                                                            <span>
                                                                                <!-- Sales -->
                                                                                {{external.department || '-'}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Customer Status</span>
                                                                        <div class="callreport-details">
                                                                            <span>
                                                                                <!-- Demo -->
                                                                                {{external.status || "-"}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Secondary Attendees</span>
                                                                        <div class="callreport-details-email">
                                                                            <span class="chipmailCallReport"  v-for="(secondaryExternal, index) in external.secondary_email" :key="index">{{secondaryExternal}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span  style="font-size: 14px;color: #00448b;font-weight: 600;">Other Attendees</span>
                                                                        <div class="callreport-details-email">
                                                                            <span class="chipmailCallReport"   v-for="(otherExternal, index) in external.other_email"  :key="index">{{otherExternal}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-else-if="callReportData.receiver_type == 'lead'">
                                            <div class="col-lg-12" >
                                                <div class="callreport-example mb-5" v-for="(lead, index) in callReportData.lead_info" :key="index">
                                                    <div class="description descriptionblue" style="border-radius: 5px 5px 0px 0px;">
                                                        <div class="description-text">
                                                            <h5 class="pl-4 text-uppercase">Receiver Details</h5>
                                                        </div>
                                                    </div>
                                                    <div class="call-report-section" style="background: #fff;border-radius: 0px 0px 5px 5px;" >
                                                        <div clss="callreportview">
                                                            <div class="pl-8 pr-10 py-5">
                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Lead Name</span>
                                                                        <div class="row">
                                                                            <div class="col-lg-9 callreport-details mt-2">
                                                                                <span>{{lead.name || "-" }}</span>
                                                                            </div>
                                                                            <div class="callreport-details pt-2 col-lg-3">
                                                                                <button class="btn btn-new-primary btn-des">
                                                                                    <span class="text-white font-weight-bold ml-1 hidden-sm-down" @click="viewLead(lead.id)">View Lead</span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Company Name</span>
                                                                        <div class="callreport-details mt-2">
                                                                            <span>
                                                                                <!-- DigiCollect India Private Limited -->
                                                                                {{lead.company_name || "-"}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Lead Status </span>
                                                                        <div class="callreport-details">
                                                                            <span>
                                                                                <!-- DigiCollect India Private Limited -->
                                                                                {{lead.status || "-"}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-else-if="callReportData.receiver_type == 'vendor'">
                                            <div class="col-lg-12" >
                                                <div class="callreport-example mb-5" v-for="(vendor, index) in callReportData.vendor_info" :key="index">
                                                    <div class="description descriptionblue" style="border-radius: 5px 5px 0px 0px;">
                                                        <div class="description-text">
                                                            <h5 class="pl-4 text-uppercase">Receiver Details</h5>
                                                        </div>
                                                    </div>
                                                    <div class="call-report-section" style="background: #fff;border-radius: 0px 0px 5px 5px;" >
                                                        <div clss="callreportview">
                                                            <div class="pl-8 pr-10 py-5">
                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Vendor Name</span>
                                                                        <div class="row">
                                                                            <div class="col-lg-9 callreport-details mt-2">
                                                                                <span>{{vendor.name || "-" }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pr-5 mt-5">
                                                                        <span style="font-size: 14px;color: #00448b;font-weight: 600;">Vendor Email ID</span>
                                                                        <div class="callreport-details mt-2">
                                                                            <span>
                                                                                {{vendor.vendor_primary_attendee || "-"}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-else>
                                            <div class="col-lg-12" >
                                                <div class="callreport-example mb-5" v-for="(contact, index) in callReportData.contact_info" :key="index">
                                                    <div class="description descriptionblue" style="border-radius: 5px 5px 0px 0px;">
                                                        <div class="description-text">
                                                            <h5 class="pl-4 text-uppercase">Receiver Details</h5>
                                                        </div>
                                                    </div>
                                                    <div class="call-report-section" style="background: #fff;border-radius: 0px 0px 5px 5px;" >
                                                        <div class="pl-5 pr-10 py-5">
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Contact Name</span>
                                                                    <div class="row">
                                                                        <div class="col-lg-9 callreport-details mt-2">
                                                                            <span>{{contact.name || "-"}}</span>
                                                                        </div>
                                                                        <div class="callreport-details pt-2 col-lg-3">
                                                                            <button class="btn btn-new-primary btn-des">
                                                                                <span class="text-white font-weight-bold ml-1 hidden-sm-down" @click="viewContact(contact.id)">View Contact</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Company Name</span>
                                                                    <div class="callreport-details mt-2">
                                                                        <span>
                                                                            {{contact.company_name || "-"}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" >
                                        <div class="col-lg-12">
                                            <div class="callreport-example mb-5">
                                                <!-- <div class="callreport-example"> -->
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">COMPANY</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="row">
                                                                <div class="col-lg-12 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Company Name</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            <!-- DigiCollect India Private Limited -->
                                                                            <!-- {{internal.name}} -->
                                                                            {{callReportData.internal_company ? callReportData.internal_company.name : "-"}}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-12 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Company
                                                                        Attendees</span>
                                                                    <div class="callreport-details-email"
                                                                        v-if="callReportData.internal_company">
                                                                        <span class="chipmailCallReport"
                                                                            v-for="(secondaryInternal, index) in callReportData.internal_company.company_attendees"
                                                                            :key="index">{{secondaryInternal}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Other
                                                                        Attendees</span>
                                                                    <div class="callreport-details-email"
                                                                        v-if="callReportData.internal_company">
                                                                        <span class="chipmailCallReport"
                                                                            v-for="(otherInternal, index) in callReportData.internal_company.other_email"
                                                                            :key="index">{{otherInternal}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <div class="callreport-example">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-8 text-left">EMAIL SHARED</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="row mt-5">
                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Individual</span>
                                                                    <div v-if="callReportData.recipient_email.individual.length" class="callreport-details-email">
                                                                        <span class="chipmailCallReport" v-for="(email,index) in callReportData.recipient_email.individual" :key="index">{{typeof email === 'object' ? email.email : email}}</span>
                                                                    </div>
                                                                    <div v-else class="callreport-details-email">
                                                                        <span class="chipmailCallReport">-</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Team</span>
                                                                    <div v-if="callReportData.recipient_email.team.length" class="callreport-details-email">
                                                                        <span class="chipmailCallReport" v-for="(email,index) in callReportData.recipient_email.team" :key="index">{{typeof email === 'object' ? email.email : email}}</span>
                                                                    </div>
                                                                    <div v-else class="callreport-details-email">
                                                                        <span class="chipmailCallReport">-</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <div class="callreport-example">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-8 text-left">CALL REPORT PERMISSIONS</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                <div class="row my-3" v-if="callReportData.owner_email">
                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Owner :</span>
                                                                    <span class="chipmailCallReport ml-3">{{callReportData.owner_email || "-"}}</span>
                                                                </div>
                                                                <div class="row mt-3" v-if="callReportData.author_email">
                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Author :</span>
                                                                    <span class="chipmailCallReport ml-3">{{callReportData.author_email || "-"}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-5">
                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Individual</span>
                                                                    <div v-if="callReportData.permissions.hasOwnProperty('individual')">
                                                                        <div v-if="callReportData.permissions.individual.length" class="callreport-details-email">
                                                                            <span class="chipmailCallReport" v-for="(email,index) in callReportData.permissions.individual" :key="index">{{typeof email === 'object' ? email.email_id : email}}</span>
                                                                        </div>
                                                                        <div v-else class="callreport-details-email">
                                                                            <span class="chipmailCallReport">-</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;">Team</span>
                                                                    <div v-if="callReportData.permissions.hasOwnProperty('individual')">
                                                                        <div v-if="callReportData.permissions.team.length" class="callreport-details-email">
                                                                            <span class="chipmailCallReport" v-for="(email,index) in callReportData.permissions.team" :key="index">{{typeof email === 'object' ? email.email_id : email}}</span>
                                                                        </div>
                                                                        <div v-else class="callreport-details-email">
                                                                            <span class="chipmailCallReport">-</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <div class="callreport-example">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">MEETING INFORMATION</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Call
                                                                        Report</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            <!-- Client Meeting -->
                                                                            {{callReportData.call_report_type}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Meeting
                                                                        Type</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            {{callReportData.meeting_type}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Branch</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            {{callReportData.branch_name || '-'}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Meeting
                                                                        Date & Time</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            {{ moment(callReportData.meeting_time_from_mob).format("DD MMMM YYYY")}},{{callReportData.start_time}}
                                                                            to
                                                                            {{ moment(callReportData.meeting_time_to_mob).format("DD MMMM YYYY")}},{{callReportData.end_time}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Meeting
                                                                        Location</span>
                                                                    <div class="callreport-details">
                                                                        <span>
                                                                            {{meetingLocation}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <div class="callreport-example">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">MEETING NOTES</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-0 pr-0 pt-3">
                                                            <h6
                                                                class="mt-1 font-weight-bold pl-8 fs-14 defaultDarkBlue">
                                                                <!-- Meeting Notes -->
                                                                {{ callReportData.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }}</h6>
                                                            <div class="pl-8 pr-10 py-5">
                                                                <h6 class="fw-500 fs-14 text-black"
                                                                    style="white-space: pre-wrap;word-wrap: break-word;">Subject:
                                                                    {{callReportData.meeting_notes_subject}}</h6>
                                                                <div class="example">
                                                                    <div class="output ql-snow fs-14">
                                                                        <div class="ql-editor fw-500 fs-14"
                                                                            v-html="callReportData.meeting_notes"></div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="callReportData.meeting_notes_table">
                                                                    <h6 v-if="callReportData.meeting_notes_table.length ? callReportData.meeting_notes_table.meeting_notes_table_data : false"
                                                                        class="mt-1 font-weight-bold fs-14 defaultDarkBlue">
                                                                        Table Name : <span
                                                                            class="fw-500 fs-14 text-black">{{callReportData.meeting_notes_table_name || '-'}}</span>
                                                                    </h6>
                                                                    <div style="overflow: auto;"
                                                                        v-if="callReportData.meeting_notes_table.length ? callReportData.meeting_notes_table.meeting_notes_table_data : false">
                                                                        <table class="meeting-notes-table mt-3">
                                                                            <tbody>
                                                                                <tr v-for="(row,index) in callReportData.meeting_notes_table.meeting_notes_table_data"
                                                                                    :key="index">
                                                                                    <td v-for="(col,index) in row"
                                                                                        :key="index">
                                                                                        <input type="text"
                                                                                            style="height: 30px; width: 130px;"
                                                                                            v-model="row[index]" />
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                <div class="d-flex flex-wrap align-items-center my-5">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 pr-4 pl-0 py-2"
                                                                        v-for="(attachment,index) in callReportData.meeting_attachments"
                                                                        :key="index">
                                                                        <div class="d-flex align-items-center px-5 py-3 pointer" @click="openFolder(attachment)"
                                                                            style="background: #ecf1f9; border-radius: 6px;">
                                                                            <div class="d-flex align-items-center"
                                                                                style="width:90%">
                                                                                <div>
                                                                                    <img v-if="attachment.name.endsWith('.pdf')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.png')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.jpg')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                                                    <img v-else-if="attachment.name.endsWith('.svg')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.xls')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.doc')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.docx')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                                                    <!-- <img v-else-if="attachment.name.endsWith('.htm')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.html')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" /> -->
                                                                                    <img v-else-if="attachment.name.endsWith('.ppt')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.pptx')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.txt')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.xlsx')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                                                    <!-- <img v-else-if="attachment.name.endsWith('.bmp')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.gif')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" /> -->
                                                                                    <img v-else-if="attachment.name.endsWith('.jpeg')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                                                    <!-- <img v-else-if="attachment.name.endsWith('.tiff')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" /> -->
                                                                                    <img v-else-if="attachment.name.endsWith('.avi')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                                                    <!-- <img v-else-if="attachment.name.endsWith('.flv')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.mpg')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" /> -->
                                                                                    <img v-else-if="attachment.name.endsWith('.mpeg')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.mp3')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.mp4')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                                                    <!-- <img v-else-if="attachment.name.endsWith('.wav')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                                                    <img v-else-if="attachment.name.endsWith('.wmv')"
                                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" /> -->
                                                                                </div>
                                                                                <div class="col">
                                                                                    <div
                                                                                        class="d-flex justify-content-between">
                                                                                        <el-tooltip
                                                                                            :content="attachment.name"
                                                                                            placement="top">
                                                                                            <div
                                                                                                class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                                {{attachment.name}}
                                                                                            </div>
                                                                                        </el-tooltip>
                                                                                        <!-- <div class="text-right" v-if="attachment.url == undefined" @click="getResumableURL(attachment)">
                                                                                            <i class="icon icon-refresh text-danger fs-16"></i>
                                                                                        </div>-->
                                                                                    </div>
                                                                                    <div class="fw-500">
                                                                                        ({{attachment.size | prettyBytes}})
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-5">
                                        <div class="col-lg-12">
                                            <!-- <div class="callreport-example"> -->
                                            <div class="callreport-example"
                                                v-for="(followup, index) in callReportData.follow_ups" :key="index">
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">FOLLOW UP - {{index+1}}</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 py-5">
                                                            <div class="row" style="border-radius: 5px 5px 0px 0px;">
                                                                <div class="col-lg-6">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Product
                                                                        Details</span>
                                                                </div>
                                                                <!-- <div class="col-lg-6 text-right">
                                                                    <button
                                                                        class="btn btn-primary btn-smm text-white mr-2"
                                                                        style="min-width: 9.8rem;">Create Task in
                                                                        P.M</button>
                                                                </div> -->
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Product
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span class="chipmailCallReport" v-for="(product, pro_index) in followup.products" :key="pro_index">{{product.name || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Assigned
                                                                        To</span>
                                                                    <div class="callreport-details">
                                                                        <span class="chipmailCallReport">{{followup.assigned_to.full_name || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Due
                                                                        Date & Time</span>
                                                                    <div class="callreport-details">
                                                                        <span>{{ moment(followup.due_date).format("MM/DD/YYYY") }} , {{followup.time}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Price</span>
                                                                    <div class="callreport-details pt-6">
                                                                        <span>
                                                                            <span
                                                                                class="fs-13">{{followup.price == 0 ? "" : currency}} {{followup.price == 0 ? "N/A" : followup.price}}</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-12 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Notes</span>
                                                                    <div class="callreport-details">
                                                                        <span>{{followup.notes || "-"}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="row">
                                                                <div class="col-lg-6 pr-10">
                                                                    <div class="callreport-details mt-2">
                                                                        <span>Product Name :</span>
                                                                        <span>
                                                                            {{followup.product}}
                                                                        </span>
                                                                    </div>

                                                                    <div class="callreport-details mt-3" style="padding-top: 15px;margin-top: 22.5px;">
                                                                        <span>Status :</span>
                                                                        <span>
                                                                            <span class="badgelabel badgelabel-warning fs-13">
                                                                                {{followup.status}}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pl-10">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;visibility: hidden;">Company Name</span>
                                                                    <div class="callreport-details mt-2">
                                                                        <span>Assigned To :</span>
                                                                        <span>
                                                                            {{followup.assigned_to_user}}
                                                                        </span>
                                                                    </div>
                                                                    <div class="callreport-details mt-6">
                                                                        <span>Due Date :</span>
                                                                        <span>
                                                                            {{ moment(followup.due_date).format("MM/DD/YYYY") }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-12 mt-3 pl-0">
                                                                <span style="font-size: 14px;color: #303031;font-weight: 600;">Notes:</span>
                                                                <div class="callreport-details">
                                                                    <span>
                                                                        {{followup.notes}}
                                                                    </span>
                                                                </div>
                                                            </div>-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="callreport-example mb-5"
                                                v-for="(salestarget, index) in callReportData.sales_target"
                                                :key="index">
                                                <!-- <div class="callreport-example"> -->
                                                <div class="description descriptionblue"
                                                    style="border-radius: 5px 5px 0px 0px;">
                                                    <div class="description-text">
                                                        <h5 class="pl-4">SALES TARGET - {{index+1}}</h5>
                                                    </div>
                                                </div>
                                                <div class="call-report-section"
                                                    style="background: #fff;border-radius: 0px 0px 5px 5px;">
                                                    <div clss="callreportview">
                                                        <div class="pl-8 pr-10 pt-5 pb-5">
                                                            <div class="row">
                                                                <div class="col-lg-6 pr-10">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Sales
                                                                        Target for Year -
                                                                        {{salestarget.forecast.target_year}}</span>
                                                                    <!-- <div class="callreport-details mt-2">
                                                                        <span>Product Name :</span>
                                                                        <span>
                                                                            {{salestarget.forecast.product}}
                                                                        </span>
                                                                    </div>-->
                                                                </div>
                                                                <!-- <div class="col-lg-6 pl-10">
                                                                    <span style="font-size: 14px;color: #00448b;font-weight: 600;visibility: hidden;">Company Name</span>
                                                                    <div class="callreport-details mt-2">
                                                                        <span>Customer Name :</span>
                                                                        <span>
                                                                            {{salestarget.forecast.customer_company}}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div class="row">
                                                                    <div class="col-lg-6 pr-10">
                                                                        <div class="callreport-details mt-2">
                                                                            <span>Branch Name :</span>
                                                                            <span>
                                                                                {{salestarget.forecast.branch_name}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 pl-10">
                                                                        <div class="callreport-details mt-2">
                                                                            <span>Department Name :</span>
                                                                            <span>
                                                                                {{salestarget.forecast.department}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                -->
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Product
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span class="secondary-product mr-1" v-for="(product,pr_index) in salestarget.forecast.product">{{product.name || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Company
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span>{{salestarget.forecast.customer_name || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Branch
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span>{{salestarget.forecast.branch_name || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 pr-5 mt-5">
                                                                    <span
                                                                        style="font-size: 14px;color: #00448b;font-weight: 600;">Department
                                                                        Name</span>
                                                                    <div class="callreport-details">
                                                                        <span>{{salestarget.forecast.department || '-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="callreport-details"
                                                                style="border-bottom: 1px solid transparent;">
                                                                <div class="table-responsive mt-5">
                                                                    <table class="table table-sales">
                                                                        <thead>
                                                                            <tr style="background-color: #0b61fc;">
                                                                                <th
                                                                                    style="border-collapse: separate;border-radius: 4px 0px 0px 0px;">
                                                                                    Jan</th>
                                                                                <th>Feb</th>
                                                                                <th>Mar</th>
                                                                                <th>Apr</th>
                                                                                <th>May</th>
                                                                                <th>June</th>
                                                                                <th>July</th>
                                                                                <th>Aug</th>
                                                                                <th>Sep</th>
                                                                                <th>Oct</th>
                                                                                <th>Nov</th>
                                                                                <th>Dec</th>
                                                                                <th
                                                                                    style="border-collapse: separate;border-radius: 0px 4px 0px 0px;">
                                                                                    Total Sales Target</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <!-- $ 5,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.jan)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 4,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.feb)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.mar)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 1,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.apr)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.may)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.jun)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.jul)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.aug)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.sept)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.oct)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.nov)}}
                                                                                </td>
                                                                                <td>
                                                                                    <!-- $ 6,000 -->
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.dec)}}
                                                                                </td>
                                                                                <td style="background-color: #c5daf2;">
                                                                                    {{callReportData.currency.symbol}}
                                                                                    {{formatPrice(salestarget.forecast.target.total)}}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <preview @hidePreview="hidePreview" v-if="previewVisible" :filePreview="previewFile"></preview>
                <files-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></files-viewer>
            </div>
</template>
<script>
    import { EventBus } from "./eventBus/nav-bar-event.js";
    import FilesViewer from './FilesViewerCallReport.vue';
    import QrcodeVue from "qrcode.vue";
    import callreport from "./mixins/callreport";
    import print from "./mixins/print";
    var mime = require('mime-types')
    import Preview from './PreviewCallAttacthment';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import moment from "moment";
    import {
        quillEditor
    } from 'vue-quill-editor'
    // import theme style
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    export default {
        data() {
            return {
                currency: "",
                selectDraftSend: "",
                selectDate: "",
                valueqr: "https://example.com",
                size: 100,
                callReportData: {},
                internalCompanyObject: "",
                meetingLocation: "",
                ajaxCallinprogress: false,
                show_file_viewer: false,
                doc_file_url_type: '',
                file_url_for_view: '',
                file_name_for_view: '',
                file_type_for_view: '',
                previewVisible: false,
                previewFile:{},
                previewId:'',
                previewAccId:'',
                preview_file: '',
            };
        },
        mixins: [callreport, print],
        components: {
            QrcodeVue,
            quillEditor,
            HalfCircleSpinner,
            FilesViewer,
            Preview
        },
        computed: {
            account() {
                return this.$store.getters.selectedCompany;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
        },
        methods: {
            previewImage(file) {
                this.previewVisible = true;
                this.previewFile = this.preview_file;
                // this.previewId = id;
                // this.previewAccId = file['account_id'];
                // EventBus.$emit('show image');
                // this.preview_data = []
            },
            hidePreview(){
                this.previewVisible = false
            },
            viewFile(file) {
                this.file_url_for_view = file.url || "";
                this.file_name_for_view = file.name;
                this.show_file_viewer = true;
                this.file_type_for_view = file.content_type
            },
            hideFileViewer() {
              this.show_file_viewer = false;
            },
            openFolder(file) {
                let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
                file['content_type'] = content_type;
                this.preview_file = file;
                if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                    this.viewFile(this.preview_file)
                } else {
                    // setTimeout(() => {
                    //     this.preview_data = this.files.filter(x => x.name === file.name)
                    // }, 1000);
                    // setTimeout(() => {
                        this.previewImage(file)
                    // }, 1500);
                }
            },
            //Redirect the lead info section to view lead data
            /**@params = id */
            viewLead(id) {
                if(this.userPermissions.leads.permitted_actions.view){
                    localStorage.setItem("leads_type","Manual")
                    this.$router.push('/leads/viewLeads/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //Redirect the customer info section to view lead data
            /**@params = id */
            viewCustomer(id) {
                if(this.userPermissions.customers.permitted_actions.view){
                    this.$router.push('/view_customer/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //Redirect the contact info section to view lead data
            /**@params = id */
            viewContact(id) {
                if(this.userPermissions.contacts_business.permitted_actions.view){
                    localStorage.setItem("contact_type","business")
                    this.$router.push('/contacts/view_contact/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //go back to the list view
            goBackToList() {
                this.$router.push('/callreportlist');
            },
            //setting the format of the price
            /**@params = value */
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace(",", ".");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            handleClick() {},
            moment(date) {
                return moment(date);
            },
            //API call to get the call report data 
            async getCallReport() {
                try {
                    this.ajaxCallInProgress = true;
                    let res = await this.getCallReportById(this.$route.params.id);
                    this.ajaxCallInProgress = false;
                    this.callReportData = res.response;

                    let meetinglocation = this.callReportData.meeting_location;
                    if (
                        meetinglocation.street &&
                        meetinglocation.state &&
                        meetinglocation.city &&
                        meetinglocation.country &&
                        meetinglocation.zip_code
                    ) {
                        this.meetingLocation =
                            meetinglocation.street +
                            ", " +
                            meetinglocation.state +
                            ", " +
                            meetinglocation.city +
                            ", " +
                            meetinglocation.country +
                            ", " +
                            meetinglocation.zip_code;
                    } else if (meetinglocation.city && meetinglocation.country) {
                        this.meetingLocation =
                            meetinglocation.city + ", " + meetinglocation.country;
                    } else if (meetinglocation.country) {
                        this.meetingLocation = meetinglocation.country;
                    }
                    let start_date = this.callReportData.start_date
                    let start_time = this.callReportData.start_time

                    var startbits = start_date.split(/\D/);
                    var date1 = startbits[2] + '-' + startbits[1] + '-' + startbits[0];
                    var timeAndDate = moment(date1 + ' ' + start_time);
                    let startData = moment(timeAndDate).format();
                    let startDateTime = new Date(startData)
                    //End Date & Time
                    let end_date = this.callReportData.end_date
                    let end_time = this.callReportData.end_time
                    var endbits = end_date.split(/\D/);
                    var date2 = endbits[2] + '-' + endbits[1] + '-' + endbits[0];
                    var timeAndDate = moment(date2 + ' ' + end_time);
                    let endData = moment(timeAndDate).format();
                    let endDateTime = new Date(endData)
                    //Added the data in Data Fields
                    this.callReportData.meeting_time_from = startDateTime
                    this.$forceUpdate()
                    this.callReportData.meeting_time_to = endDateTime
                    this.$forceUpdate()
                } catch (reason) {
                    this.ajaxCallInProgress = false;
                }
            },
        },
        mounted(){
            EventBus.$on('hide image',() =>{
                this.previewVisible = false;
            });
            //setting the currency form logged in user api
            this.currency = this.loggedInUser.currency.symbol;
        },
        created() {
            this.getCallReport();
            this.internalCompanyObject = this.account;
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
        }
    };
</script>
<style>
    .callreport-example {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        position: relative;
        background: #fff;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
    }

    .callreport-example>.description {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 16px;
        border-bottom: 2px solid #cdd2da;
    }

    .callreport-example>.description.descriptionblue {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px 16px;
        border-bottom: 1px solid transparent;
        background-color: #005dae;
    }

    .callreport-example>.description .description-text h2,
    .callreport-example>.description .description-text h3,
    .callreport-example>.description .description-text h4,
    .callreport-example>.description .description-text h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .callreport-example>.description.descriptionblue .description-text h5 {
        color: #fff !important;
    }

    .callreport-example>.description .description-text img {
        height: 65px;
    }

    .callreport-pm {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        position: relative;
        background: #fff;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .callreport-pm>.description.descriptionblue {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 16px;
        border-bottom: 2px solid #cdd2da;
    }

    .callreport-pm>.description.descriptionblue {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 6px 16px;
        border-bottom: 1px solid transparent;
        background-color: transparent;
    }

    .callreport-pm>.description.descriptionblue .description-text {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: flex-first;
        align-content: flex-first;
    }

    .callreport-pm>.description.descriptionblue .description-text h2,
    .callreport-pm>.description.descriptionblue .description-text h3,
    .callreport-pm>.description.descriptionblue .description-text h4,
    .callreport-pm>.description.descriptionblue .description-text h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .callreport-pm>.description.descriptionblue .description-text h5 {
        color: #fff !important;
    }

    .callreport-pm>.description.descriptionblue .description-text span {
        color: #00448b !important;
    }

    .callreport-pm>.description .description-text img {
        height: 65px;
    }

    .callreport-pm>.description.descriptionblue .head-toolbar {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: end;
        align-content: flex-end;
    }

    .callreport-example>.description .text-header-center {
        font-size: 20px;
        color: #303031;
        font-weight: 600;
        text-transform: uppercase;
    }

    .callreport-example>.call-report-section {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-flex: 1;
        -webkit-flex: 1 0 auto;
        -ms-flex: 1 0 auto;
        flex: 1 0 auto;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
    }

    .callreport-example>.call-report-section>.callreportview {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        border-bottom: none;
        padding: 2.4rem;
    }

    .aU5 {
        height: 86px;
        position: relative;
        width: 105px;
        margin: 67px 48px;
        border-radius: 4px;
    }

    .aRh,
    .aRg,
    .aRj {
        font-weight: bold;
        position: absolute;
        text-align: center;
        width: 85px;
    }

    .aRh {
        color: #fff;
        font-size: 14px;
        top: 1px;
        background: #00448b;
        border-radius: 6px 6px 0px 0px;
        height: 30px;
        padding-top: 4px;
    }

    .aRg {
        color: #303031;
        font-size: 20px;
        top: 30px;
        background: #fff;
        height: 40px;
        border-bottom: 2px dashed #ddd;
        padding: 4px 20px;
    }

    .aRj {
        color: #303031;
        font-size: 15px;
        top: 70px;
        background: #fff;
        border-radius: 0px 0px 6px 6px;
        height: 30px;
        padding-top: 4px;
    }

    .callreport-details {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.21;
        letter-spacing: 0.6px;
        color: #303031;
        padding-top: 22px;
        padding-bottom: 7px;
        border-bottom: 1px solid #4e5764;
        word-wrap: break-word;
    }

    .callreport-details-email {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.21;
        letter-spacing: 0.6px;
        color: #303031;
        padding-top: 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #4e5764;
    }

    .callreport-notes {
        border-radius: 5px;
        border: solid 0.5px #00448b;
        background-color: #fff;
        padding: 10px 25px 0px 33px;
        margin-top: 10px;
    }

    ol.s {
        list-style-type: upper-greek;
        padding-inline-start: 10px;
    }

    ol.s li {
        font-size: 13px;
        color: #303031;
        padding: 0px 10px;
    }

    ol.n {
        list-style-type: lower-alpha;
    }

    ol.n li {
        font-size: 13px;
        color: #303031;
        padding: 0px 10px;
    }

    .table.table-sales {
        border-radius: 5px;
    }

    .table-sales {
        border: solid 1px #7f8083;
    }

    .table-sales td,
    .table-sales th {
        border: 1px solid #7f8083;
    }

    .table thead th {
        vertical-align: bottom;
        border-bottom: 0px solid #7f8083;
    }

    .table-sales thead td,
    .table-sales thead th {
        border-bottom-width: 0px;
    }

    .table.table-sales thead th {
        border-bottom: 0px solid #e0e3e6 !important;
        font-weight: bold;
        font-size: 14px !important;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #fff !important;
        text-transform: none !important;
    }

    .table.table-sales tbody td {
        padding: 1.1rem 1.1rem !important;
        color: #303031;
        font-size: 13px;
    }

    .qrcodecr-block {
        border-radius: 6px;
        width: 110px;
        height: 110px;
        position: relative;
        display: inline-block;
        white-space: nowrap;
        vertical-align: bottom;
    }

    .qrcodecr-content {
        text-align: center;
        margin: 7px auto;
    }

    .qrcr-logo {
        position: absolute;
        margin-top: 34px;
        margin-left: 35px;
        width: 45px;
    }
    .secondary-product {
        padding: 2px 4px;
        border-radius: 5px;
        background-color: rgba(197, 223, 253, 0.28);
        white-space: nowrap;
        margin: 1px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewCallReport.vue